import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UpdateCouponExpiryDatetimeRequestObjectType,
  UpdateCouponExpiryDatetimeResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseUpdateCouponExpiryDatetimeApiInterface {
  updateCouponExpiryDatetimeApi: UseMutateAsyncFunction<
    UpdateCouponExpiryDatetimeResponseType,
    Error,
    UpdateCouponExpiryDatetimeRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useUpdateCouponExpiryDatetimeApi =
  (): UseUpdateCouponExpiryDatetimeApiInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const updateCouponExpiryDatetime = (
      requestObject: UpdateCouponExpiryDatetimeRequestObjectType
    ) => {
      return nwApplicationService.updateCouponExpiryDatetime(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      updateCouponExpiryDatetime,
      {
        mutationKey: ['updateCouponExpiryDatetimeApi']
      }
    );

    return {
      updateCouponExpiryDatetimeApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useUpdateCouponExpiryDatetimeApi };
